import {
  TEMPLATE_OPTIONS,
  TEMPLATE_OPTIONS_SIMPLE,
} from 'common/constants/sm-constants';
import {
  FormMetaModel,
  SmMetaInputModel,
  SmRadioModel,
  SmMetaSelectModel,
} from 'common/models/utility-models/meta-model';

export class RegisterStep1MetaModel extends FormMetaModel {
  constructor() {
    super(
      '',
      '',
      '',
      3,
      null,
      true,
      'step1',
      '',
      ' row align-items-start justify-content-start'
    );
  }

  override initProperties(): any {
    const formInfo = super.initProperties();

    const firstName = new SmMetaInputModel(
      'firstName',
      'firstName',
      'input',
      true,
      'col-12 col-md-4',
      1,
      1,
      'First Name',
      'text',
      "^(?=.*[a-zA-Z])[a-zA-Z '-]+$",
      false,
      true,
      true,
      false,
      100,
      1,
      
    );

    const middleName = new SmMetaInputModel(
      'middleName',
      'middleName',
      'input',
      false,
      'col-12 col-md-4',
      1,
      1,
      'Middle Name',
      'text',
      "^(?=.*[a-zA-Z])[a-zA-Z '-]+$",
      false,
      true,
      true,
      false,
      100,
      0,
      
    );
    const lastName = new SmMetaInputModel(
      'lastName',
      'lastName',
      'input',
      true,
      'col-12 col-md-4',
      1,
      1,
      'Last Name',
      'text',
      "^(?=.*[a-zA-Z])[a-zA-Z '-]+$",
      false,
      true,
      true,
      false,
      100,
      1,
      
    );

    // '[a-zA-Z][a-zA-Z ]+
    const fullName = new SmMetaInputModel(
      'fullName',
      'fullName',
      'input',
      false,
      'col-12 col-md-4',
      1,
      1,
      'Full Name',
      'text',
      "^(?=.*[a-zA-Z])[a-zA-Z '-]+$",
      true,
      true,
      true,
      false,
      300,
      1
    );

    const gender = new SmRadioModel(
      'gender',
      'gender',
      'radio',
      true,
      'col-xs-12 col-sm-12 col-md-5 col-lg-5 ',
      1,
      1,
      'Gender',
      'checkbox',
      '',
      false,
      true,
      true,
      false,
      0,
      0,
      false,
      false,
      { evalKey: '', evalParam: [] },
      '',
      2,
      [
        {
          key: 'male',
          value: ['off'],
          label: 'Male',
          decisiveKey: 'val',
          prop: { key: 'required', value: true },
        },
        {
          key: 'female',
          value: ['off'],
          label: 'Female',
          decisiveKey: 'val',
          prop: { key: 'required', value: true },
        },
        {
          key: 'other',
          value: ['off'],
          label: 'Other',
          decisiveKey: 'val',
          prop: { key: 'required', value: true },
        },
      ]
    );
    const age = new SmMetaInputModel(
      'age',
      'age',
      'input',
      true,
      'col-12 col-md-4',
      1,
      1,
      'Age',
      'number',
      '',
      false,
      true,
      true,
      false,
      3,
      1,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      '',
      { evalKey: '', evalParam: [] },
      false,
      [],
      false,
      '',
      null,
      true,
      false,
      false,
      'Age must be less than 20 years as on 31ˢᵗ December of current year',
      true,
      true
    );
   
    const mobileNumber = new SmMetaInputModel(
      'mobileNumber',
      'mobileNumber',
      'input',
      true,
      'col-12 col-md-4',
      1,
      1,
      'Phone Number',
      'number',
      '',
      false,
      true,
      true,
      false,
      10,
      10,
      
   
    );

    const landlineNumber = new SmMetaInputModel(
      'landlineNumber',
      'landlineNumber',
      'input',
      false,
      'col-12 col-md-4 ',
      1,
      1,
      'Alternate Number',
      'number',
      '',
      false,
      true,
      true,
      false,
      10,
      10,
      
    );
    const email = new SmMetaInputModel(
      'email',
      'email',
      'input',
      true,
      'col-12 col-md-4 ',
      1,
      1,
      'Email Id',
      'text',
      '',
      false,
      true,
      true,
      false,
      100,
      1,
      
    );
    const alternativeEmail = new SmMetaInputModel(
      'alternativeEmail',
      'alternativeEmail',
      'input',
      false,
      'col-12 col-md-4 ',
      1,
      1,
      'Alternative Email Id',
      'text',
      '',
      false,
      true,
      true,
      false,
      100,
      1,
      
    );
    const city = new SmMetaInputModel(
      'city',
      'city',
      'input',
      true,
      'col-12 col-md-4 ',
      1,
      1,
      'City/Town',
      'text',
      "^(?=.*[a-zA-Z])[a-zA-Z '-]+$",
      false,
      true,
      true,
      false,
      100,
      1,
      
    );

    const stateId = new SmMetaSelectModel(
      'stateId',
      'stateId',
      'select',
      true,
      'col-12 col-md-4 ',
      1,
      1,
      'State/UT of domicile',
      'select',
      '',
      false,
      true,
      true,
      false,
      0,
      0,
      false,
      TEMPLATE_OPTIONS,
      'stateName',
      'id'
    );

    const district_id = new SmMetaSelectModel(
      'district_id',
      'district_id',
      'select',
      true,
      'col-12 col-md-4',
      1,
      1,
      'District',
      'select',
      '',
      false,
      true,
      true,
      false,
      0,
      0,
      false,
      TEMPLATE_OPTIONS,
      'district',
      'id',
    );

    // const buttons = {
    //     submit: new SmBtnMetaModel('Submit', '', true, false, true, true),
    //     isFormControl: false
    // };

    return {
      formInfo,
      firstName,
      middleName,
      lastName,
      fullName,
      gender,
      age,
      mobileNumber,
      landlineNumber,
      email,
      alternativeEmail,
      city,
      stateId,
      district_id,
    };
  }
}
